import React from 'react';
import styled, { StyledComponentClass } from 'styled-components';
import { colors, sizes } from '../../styles';
import { IconButton } from '../../atoms/buttons';
import { withClickOutside } from '../../utils/click-outside';

export type IconLocations =
  | 'top-left'
  | 'top-right'
  | 'bottom-left'
  | 'bottom-right';

export interface Props {
  children?: any;
  className?: string;
  iconLocation?: IconLocations;
}

export interface State {
  isOpened: boolean;
}

class PanelTooltip extends React.Component<Props, State> {
  public static defaultProps: Props = {
    iconLocation: 'top-right',
  };

  constructor(props: Props) {
    super(props);
    this.state = { isOpened: false };
  }

  public handleToggle = () => {
    this.setState({
      isOpened: !this.state.isOpened,
    });
  };

  public handleClickOutside = () => {
    this.setState({
      isOpened: false,
    });
  };

  public render() {
    const { children, className, iconLocation } = this.props;
    const { isOpened } = this.state;

    return (
      <div
        className={`${className} ${iconLocation} ${isOpened ? 'isOpened' : ''}`}
      >
        <div className="parent-mask" onClick={this.handleClickOutside} />
        {isOpened && (
          <div className="uikit-tooltip">
            <div className="uikit-inner">{children}</div>
          </div>
        )}
        <div className="uikit-icon">
          <IconButton
            baseColor={colors.grey700}
            icon="info"
            onClick={this.handleToggle}
            size="md"
          />
        </div>
      </div>
    );
  }
}

const WrappedPanelTooltip = withClickOutside(PanelTooltip);
const iconHeight = '3rem';

export default styled(WrappedPanelTooltip)`
  width: ${iconHeight};
  height: ${iconHeight};
  position: absolute;
  font-size: 13px;

  &.isOpened {
    width: 100%;
    height: 100%;
    z-index: 1;
  }
  .parent-mask {
    width: 100%;
    height: 100%;
  }
  .uikit-icon {
    width: ${iconHeight};
    height: ${iconHeight};
    position: absolute;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .uikit-inner {
    padding: 1.5rem;
    line-height: 1.75;
  }
  .uikit-tooltip {
    max-width: 360px;
    border-radius: 4px;
    background: ${colors.black};
    box-shadow: 0 0 4px 0 rgba(0, 0, 0, 0.25);
    color: white;
    position: absolute;
  }

  /** Position the icon inside the panel */
  &.top-left {
    top: ${sizes.block.sm};
    left: ${sizes.block.sm};
  }
  &.top-right {
    top: ${sizes.block.sm};
    right: ${sizes.block.sm};
  }
  &.bottom-left {
    bottom: ${sizes.block.sm};
    left: ${sizes.block.sm};
  }
  &.bottom-right {
    bottom: ${sizes.block.sm};
    right: ${sizes.block.sm};
  }

  /** Position the tooltip content flyout */
  &.bottom-left .uikit-tooltip,
  &.bottom-left .uikit-icon {
    bottom: 0;
    left: 0;
  }
  &.bottom-right .uikit-tooltip,
  &.bottom-right .uikit-icon {
    bottom: 0;
    right: 0;
  }
  &.top-left .uikit-tooltip,
  &.top-left .uikit-icon {
    left: 0;
    top: 0;
  }
  &.top-right .uikit-tooltip,
  &.top-right .uikit-icon {
    right: 0;
    top: 0;
  }
  &.top-left .uikit-inner,
  &.bottom-left .uikit-inner {
    border-left: 1px solid rgba(255, 255, 255, 0.1);
    margin-left: 45px;
  }
  &.top-right .uikit-inner,
  &.bottom-right .uikit-inner {
    border-right: 1px solid rgba(255, 255, 255, 0.1);
    margin-right: 45px;
  }
`;
